import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/daps/';

class DapsService {
    constructor() {
        this.idCliente = null;
        this.idContribuinte = null;
        this.idNfsPessoa = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    salvar(daps) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        console.log(JSON.stringify(daps));
        return axios.post(API_URL + 'create?idCliente=' + this.idCliente + '&idContribuinte=' + this.idContribuinte, JSON.stringify(daps),
            { headers: this.headers });
    }

    salvarRecusaDaps(dapsRecusa) {
        return axios.post(API_URL, JSON.stringify(dapsRecusa), { headers: this.headers });
    }

    validarAliquota(valorAliquota, regimeTributacao, aliquotaServico, tipoRecolhimento) {
        return axios.get(API_URL + 'aliquotaTipRec?valorAliquota=' + valorAliquota
            + '&regimeTributacao=' + regimeTributacao
            + '&aliquotaServico=' + aliquotaServico
            + '&tipoRecolhimento=' + tipoRecolhimento, { headers: this.headers });
    }

    validarAliquotaV2(valorAliquota, regimeTributacao, aliquotaServico, tipoRecolhimento, idBeneficio) {
        return axios.get(API_URL + 'validarAliquota?valorAliquota=' + valorAliquota
            + '&regimeTributacao=' + regimeTributacao
            + '&aliquotaServico=' + aliquotaServico
            + '&tipoRecolhimento=' + tipoRecolhimento
            + '&idBeneficio=' + idBeneficio, { headers: this.headers });
    }

    validarTela(tipoEmissao, idServico, tipoRecolhimento, regimeTributacao) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;

        return axios.get(API_URL + 'tela?idCliente=' + this.idCliente
            + '&tipoEmissao=' + tipoEmissao
            + '&idContribuinte=' + this.idContribuinte
            + '&idServico=' + idServico
            + '&tipoRecolhimento=' + tipoRecolhimento
            + '&regimeTributacao=' + regimeTributacao, { headers: this.headers });
    }

    validarTelaV2(tipoEmissao, idServico, tipoRecolhimento, regimeTributacao, pessoa) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;

        return axios.get(API_URL + 'tela_v2?idCliente=' + this.idCliente
            + '&tipoEmissao=' + tipoEmissao
            + '&idContribuinte=' + this.idContribuinte
            + '&idServico=' + idServico
            + '&tipoRecolhimento=' + tipoRecolhimento
            + '&regimeTributacao=' + regimeTributacao
            + '&pessoa=' + pessoa, { headers: this.headers });
    }


    listAllFiltroPesquisar(filtro, numero, dataIni, dataFin, tipoDaps, filtroSituacao, filtroIntermediario) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        this.idNfsPessoa = LoginService.currentUserValue.contribuinte.idNfsPessoa;
        return axios.get(API_URL + 'consulta?idCliente=' + this.idCliente
            + '&idNfsPessoa=' + this.idNfsPessoa
            + '&filtro=' + filtro
            + '&numero=' + numero
            + (dataIni ? ('&dataIni=' + dataIni) : "")
            + (dataFin ? ('&dataFin=' + dataFin) : "")
            + '&tipoDaps=' + tipoDaps
            + '&filtroSituacao=' + filtroSituacao
            + '&filtroIntermediario=' + filtroIntermediario,
            { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    listMotivoRecusaDaps(id) {
        return axios.get(API_URL + 'AllMotivoRecusaDaps?id=' + id, { headers: this.headers });
    }

    getDapsId(id) {
        return axios.get(API_URL + id, { headers: this.headers });
    }

    cancelar(idDaps) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.post(API_URL + 'cancela?idCliente=' + this.idCliente
            + '&idDaps=' + idDaps,
            null,
            { headers: this.headers });
    }

    carregarAnexosDaps(idDaps) {
        return axios.get(API_URL + 'allAnexosDaps?idDaps=' + idDaps, { headers: this.headers });
    }

    validarPrestadorValido(idCliente, tipoTomdor, origem, idPessoa, documentoEmissor) {
        return axios.get(API_URL + 'validarPrestadorValido?idCliente=' + idCliente + '&tipoTomdor=' + tipoTomdor + '&origem=' + origem + '&idPessoa=' + idPessoa + '&documentoEmissor=' + documentoEmissor, { headers: this.headers });
    }

    validarLocalidade(idCliente, idLocalidade, tipoRecolhimento) {
        return axios.get(API_URL + 'validarLocalidade?idCliente=' + idCliente + '&idLocalidade=' + idLocalidade + '&tipoRecolhimento=' + tipoRecolhimento, { headers: this.headers });
    }

    downloadAnexo(id, type, nome) {
        return axios({
            url: API_URL + "exportDapsAnexo?idAnexo=" + id,
            method: "POST",
            responseType: "blob",
            data: null,
            headers: this.headers
        }).then(response => {
            var fileURL = window.URL.createObjectURL(
                new Blob([response.data], { type: type })
            );
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            console.log(response);
            fileLink.setAttribute("download", nome);
            document.body.appendChild(fileLink);
            fileLink.click();
        });
    }

    enviarPorEmail(idDaps, emails, comentarios) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'enviarEmail?idCliente=' + this.idCliente
            + '&idDaps=' + idDaps
            + '&emails=' + emails
            + '&comentarios=' + comentarios,
            { headers: this.headers });
    }
}

export default new DapsService();